import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DialogService } from '../bootstrap-modal/dialog.service';
import { TextDialogComponent } from './text-dialog.component';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TextDialogService {
  constructor(private dialogService: DialogService) {}

  showConfirm(title: string, message: string): Observable<string> {
    return TextDialogComponent.showConfirmationDialogModal(
      this.dialogService,
      { title, message }
    ).pipe(
      filter((result: string | null): result is string => result !== null)
    );
  }

  confirm(title: string, message: any, cancelText = "Cancel", confirmText = "Ok"): Promise<any> {
    return TextDialogComponent
      .showConfirmationDialogModal(this.dialogService, { title, message, confirmText, cancelText })
      .toPromise()
      .then(result => {
        if (result === null) {
          console.log("User cancelled the dialog");
          
        }
        return result;
      });
  }
}